<template>
  <v-row >
    <v-dialog
      v-model="dialog"
      
      max-width="600px"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn text
          style="margin-top:10px"
          color="primary"
          dark
          v-bind="attrs"
          v-on="on"
        >
          Button {{sequence}}
          <v-icon
        right
        dark
      >
        mdi-pencil
      </v-icon>
        </v-btn>
      </template>
      <v-card>
        <v-toolbar
              color="primary"
              dark
            >Header Button {{sequence}}</v-toolbar>
        <v-card-text>
          <v-container>
              <v-form
                  ref="form"
                  v-model="valid"
                  lazy-validation
                >
            <v-row>
              <v-col cols="12">
                <v-checkbox
                  v-model="buttonObj.show"
                  class="shrink mr-2 mt-0"
                  label="Show this button?"
                >
                </v-checkbox>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  v-model="buttonObj.label"
                  :counter="30"
                  label="Button Label*"
                  :rules="[rules.required]"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                 <v-text-field
                  v-model="buttonObj.link"
                  type="url"
                  label="Link"
                  :rules="[rules.required, rules.url]"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="6">
                <v-checkbox
                  append-icon="mdi-open-in-new"
                  v-model="buttonObj.open_in_new_window"
                  class="shrink mr-2 mt-0"
                  label="Open in new window"
                >
                </v-checkbox>
              </v-col>
              
            </v-row>
            </v-form>
          </v-container>
          <small>*indicates required field</small>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="dialog=false"
          >
            Close
          </v-btn>
          <v-btn
            color="blue darken-1"
            text
            @click="validate"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    
  </v-row>
</template>
<script>
export default {
    mounted(){
      
    },
    props: ['button', 'sequence'],
    data: () => ({
      buttonObj:{},
      dialog:false,
      valid:true,
      rules: {
          required: value => !!value || 'Required.',
          counter: value => value.length <= 20 || 'Max 20 characters',
          email: value => {
            const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            return pattern.test(value) || 'Invalid e-mail.'
          },
          url: value => {
            const expression=/[-a-zA-Z0-9@:%._\\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\\+.~#?&//=]*)?/gi;
            var regex = new RegExp(expression);
            return regex.test(value) || 'Invalid url.'
          }
        }
    }),
    watch: {
      dialog(visible) {
        if (visible) {
          console.log("In button dialog, button is", this.button)
          this.buttonObj=this.copy(this.button)
          console.log("Dialog was opened!")
        } else {
          console.log("Dialog was closed!")
        }
      }
    },
    methods: {
      copy(o) {
        var output, v, key;
        output = Array.isArray(o) ? [] : {};
        for (key in o) {
            v = o[key];
            output[key] = (typeof v === "object") ? this.copy(v) : v;
        }
        return output;
      },
      validate () {
        let hold=this.$refs.form.validate()
        if(hold){
          console.log("In ButtonDialog, validate, buttonObj is ", this.buttonObj)
          this.$emit('button', this.buttonObj, this.sequence)
          this.dialog = false
        }
      },
      
    }
}
</script>